import { render, staticRenderFns } from "./link-branding-widget.vue?vue&type=template&id=746be26f&"
import script from "./link-branding-widget.vue?vue&type=script&lang=js&"
export * from "./link-branding-widget.vue?vue&type=script&lang=js&"
import style0 from "./link-branding-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports